

import PropTypes from "prop-types";

import * as React from "react";
import { translate, Interpolate } from "react-i18next";
import settings from "settings";
import { ClanResource, Button, ButtonGroup, DialogBody, DialogContainer, DialogFooter, DialogHeader, Divider, HelperIcon } from "@wg/wows-react-uikit";

import { x } from "helpers/localization";

import styles from "./AcceptInviteDialog.scss";


class AcceptInviteDialog extends React.PureComponent {

  static propTypes = {
    clanLeveling: PropTypes.number.isRequired,
    isFetching: PropTypes.bool.isRequired,

    onClick: PropTypes.func,
    onHideDialog: PropTypes.func,

    t: PropTypes.func.isRequired
  };

  render() {
    const t = this.props.t;
    const needResource = settings.supply.clanLevelingToAccountLeveling[this.props.clanLeveling];
    const clanLevelingContent = (<Divider type="major" />, <div className={styles.info}>
                <Interpolate i18nKey={x('Чтобы пользоваться клановыми бонусами, необходимо заработать %(resource)s')} resource={<ClanResource amount={needResource} />} />
                <span className={styles.helperIcon}>
                    <HelperIcon header={t('Допуск к клановым бонусам')}>
                        <p>{t('Чтобы пользоваться клановыми бонусами, необходимо заработать определённое количество баррелей нефти.')}</p>
                        <p>{t('Количество баррелей нефти, необходимое для получения допуска, зависит от уровня клана.')}</p>
                        <p>{t('Чем сильнее клан, тем больше баррелей нефти необходимо заработать для получения допуска к бонусам.')}</p>
                    </HelperIcon>
                </span>
            </div>);
    return <DialogContainer>
                <DialogHeader>{t('Вступление в клан')}</DialogHeader>
                <DialogBody>
                    <div className={styles.confirmation + (needResource ? ' ' + styles['confirmation-complex'] : '')}>{t('Вы уверены, что хотите вступить в клан?')}</div>
                    {needResource ? clanLevelingContent : null}
                </DialogBody>
                <DialogFooter>
                    <ButtonGroup isLoading={this.props.isFetching}>
                        <Button isJustified onClick={this.props.onClick}>
                            {t('Вступить в клан')}
                        </Button>
                        <Button isJustified onClick={this.props.onHideDialog}>
                            {t('Отмена')}
                        </Button>
                    </ButtonGroup>
                </DialogFooter>
            </DialogContainer>;
  }
}

export default translate()(AcceptInviteDialog);